module.exports = __webpack_public_path__ + "static/media/89.294e31ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/89.svg
// module id = 169
// module chunks = 0